<template>
  <div>
    <h2 class="sub-header">
      Items updated in {{ currentDate | dateFormat('MMMM yyyy', false) }}
    </h2>
    <div class="tabs">
      <tab
        v-for="tab in itemStatuses"
        :key="tab.name"
        :tabAttr="tab"
        :tabTotal="getTotal(tab.name)"
        :selected="isSelected(tab.name)"
        @selectedTabsChange="selectedTabsChange"
      />
    </div>
    <div v-if="!itemCoverageDetailsData.isLoading">
      <div class="download">
        <p class="downloadTitle">
          Sample Data<span class="downloadDesc"> - Download for full report</span>
        </p>
        <button
          class="button is-pulled-right"
          type="button"
          :disabled="selectedTabs.length === 0"
          @click="download"
        >
          Download CSV
        </button>
      </div>
      <vs-table
        :columns="itemCoverageDetails"
        :dataArray="itemDetailData"
        :options="{'hover': true, 'alignLeft': true}"
        :isLoading="itemCoverageDetailsData.isLoading"
      >
        <template slot-scope="{ colValue }">
          <component
            :is="colValue.colInfo.key"
            :rowData="colValue.data"
          />
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import { ITEM_COVERAGE_STATUSES } from '@/misc/desktopCharts'
import { ITEM_COVERAGE_DETAILS } from '@/misc/tables'
import Tab from './Tab'
import product_type_id from './Category'　// eslint-disable-line
import statusKey from './Status'

export default {
  components: {
    Tab,
    product_type_id,
    statusKey
  },
  data () {
    return {
      itemStatuses: ITEM_COVERAGE_STATUSES,
      itemCoverageDetails: ITEM_COVERAGE_DETAILS,
      selectedTabs: ITEM_COVERAGE_STATUSES.map(item => item.name)
    }
  },
  computed: {
    ...mapState({
      currentDate: state => state.charts.coverageMonthDate,
      tabTotals: state => state.itemCoverage.itemCoverageTotals,
      itemCoverageDetailsData: state => state.itemCoverage.itemCoverageDetails,
      downloadLink: state => state.itemCoverage.downloadLink['url']
    }),
    itemDetailData () {
      let data = []
      for (let i = 0; i < this.selectedTabs.length; i++) {
        data.push(this.itemCoverageDetailsData[this.selectedTabs[i]])
      }
      return _.flattenDeep(data).sort((a, b) => new Date(b.updated) - new Date(a.updated)).slice(0, 10)
    }
  },
  methods: {
    selectedTabsChange (updatedTab) {
      const { value, change } = updatedTab
      if (change) {
        this.selectedTabs.push(value)
      } else {
        this.selectedTabs = this.selectedTabs.filter(t => t !== value)
      }
    },
    getTotal (name) {
      return this.tabTotals.isError ? 'N/A' : this.tabTotals[name]
    },
    isSelected (name) {
      return this.selectedTabs.includes(name)
    },
    download () {
      window.open(this.downloadLink)
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-header {
  margin-bottom: 10px;
  font-size: 20px;
}

.tabs {
  display: flex;
  justify-content: space-between;
}

.download {
  height: 80px;
  padding: 20px;
  border: $border-light;
  border-bottom: none;
  background: $white;

  .downloadTitle {
    float: left;
    font-size: 20px;

    .downloadDesc {
      color: $gray-600;
      font-size: 16px;
    }
  }

  .button {
    float: right;

    &:focus {
      border: 1px solid rgba(0, 0, 0, 0.4) !important;
    }
  }
}
</style>
